import posthog from 'posthog-js'

// The project portal and the dashboard report to one PostHog project, separate from the
// store's (USA-379). The project key is public: it can only send events. Visitors open
// tracker, quote and invoice links without signing in, so they stay anonymous.
const POSTHOG_KEY = 'phc_sQShd33i73y8sWyAzfgzLYsN6ahzsDiTa8hAREz2aD57'
const POSTHOG_HOST = 'https://us.i.posthog.com'

export const PRODUCTION_HOSTNAMES = ['projects.shopusars.com']

// Local testing opts in with VITE_POSTHOG_LOCAL=1 on the dev server; builds never honor it.
const localOptIn = import.meta.env.DEV && import.meta.env.VITE_POSTHOG_LOCAL === '1'

let started = false

export function initAnalytics(hostname = window.location.hostname, optIn = localOptIn): boolean {
  const production = PRODUCTION_HOSTNAMES.includes(hostname)
  if (started || !(production || optIn)) return started
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: 'history_change',
    autocapture: true,
    session_recording: { maskAllInputs: true },
  })
  posthog.register({ app: 'project_portal', environment: production ? 'production' : 'local' })
  started = true
  return started
}
